if (!customElements.get('hero-sticky-bar')) {
  customElements.define('hero-sticky-bar', class HeroStickyBar extends HTMLElement {
    connectedCallback() {
      const hero = this.closest('.shopify-section')?.querySelector('.landing-hero');
      if (!hero) return;

      new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting;
        this.classList.toggle('translate-y-full', !visible);
        const polaris = document.getElementById('polaris-css-lockdown-container');
        if (polaris) polaris.style.setProperty('display', visible ? 'none' : '', visible ? 'important' : '');
      }, { threshold: 0.1 }).observe(hero);
    }
  });
}
